/**
 * Generated by orval
 * Do not edit manually.
 * Veronics, Version=0.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ContactSubmissionDetailDTO,
  ContactSubmissionSummaryDTOQueryResultDTO,
  ContactSubmissionsGetContactSubmissionsParams,
  ContactSubmissionsSummaryDTO,
  FilterModelDTO,
  QueryColumnConfigDTO,
  UpdateContactSubmissionStatusDTO
} from './model';

import { customInstance } from '../custom-axios-instance';
import type { ErrorType } from '../custom-axios-instance';





/**
 * @summary Get all contact submissions with pagination, sorting and filtering
 */
export const contactSubmissionsGetContactSubmissions = (
    filterModelDTO: FilterModelDTO[],
    params?: ContactSubmissionsGetContactSubmissionsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ContactSubmissionSummaryDTOQueryResultDTO>(
      {url: `/api/site-admin/ContactSubmissions/list`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: filterModelDTO,
        params, signal
    },
      );
    }
  


export const getContactSubmissionsGetContactSubmissionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissions>>, TError,{data: FilterModelDTO[];params?: ContactSubmissionsGetContactSubmissionsParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissions>>, TError,{data: FilterModelDTO[];params?: ContactSubmissionsGetContactSubmissionsParams}, TContext> => {
    
const mutationKey = ['contactSubmissionsGetContactSubmissions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissions>>, {data: FilterModelDTO[];params?: ContactSubmissionsGetContactSubmissionsParams}> = (props) => {
          const {data,params} = props ?? {};

          return  contactSubmissionsGetContactSubmissions(data,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContactSubmissionsGetContactSubmissionsMutationResult = NonNullable<Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissions>>>
    export type ContactSubmissionsGetContactSubmissionsMutationBody = FilterModelDTO[]
    export type ContactSubmissionsGetContactSubmissionsMutationError = ErrorType<unknown>

    /**
 * @summary Get all contact submissions with pagination, sorting and filtering
 */
export const useContactSubmissionsGetContactSubmissions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissions>>, TError,{data: FilterModelDTO[];params?: ContactSubmissionsGetContactSubmissionsParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissions>>,
        TError,
        {data: FilterModelDTO[];params?: ContactSubmissionsGetContactSubmissionsParams},
        TContext
      > => {

      const mutationOptions = getContactSubmissionsGetContactSubmissionsMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const contactSubmissionsGetContactSubmissionsFilterConfig = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<QueryColumnConfigDTO[]>(
      {url: `/api/site-admin/ContactSubmissions/filter-config`, method: 'GET', signal
    },
      );
    }
  

export const getContactSubmissionsGetContactSubmissionsFilterConfigQueryKey = () => {
    return [`/api/site-admin/ContactSubmissions/filter-config`] as const;
    }

    
export const getContactSubmissionsGetContactSubmissionsFilterConfigQueryOptions = <TData = Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissionsFilterConfig>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissionsFilterConfig>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContactSubmissionsGetContactSubmissionsFilterConfigQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissionsFilterConfig>>> = ({ signal }) => contactSubmissionsGetContactSubmissionsFilterConfig(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissionsFilterConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContactSubmissionsGetContactSubmissionsFilterConfigQueryResult = NonNullable<Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissionsFilterConfig>>>
export type ContactSubmissionsGetContactSubmissionsFilterConfigQueryError = ErrorType<unknown>


export function useContactSubmissionsGetContactSubmissionsFilterConfig<TData = Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissionsFilterConfig>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissionsFilterConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissionsFilterConfig>>,
          TError,
          Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissionsFilterConfig>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContactSubmissionsGetContactSubmissionsFilterConfig<TData = Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissionsFilterConfig>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissionsFilterConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissionsFilterConfig>>,
          TError,
          Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissionsFilterConfig>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContactSubmissionsGetContactSubmissionsFilterConfig<TData = Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissionsFilterConfig>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissionsFilterConfig>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useContactSubmissionsGetContactSubmissionsFilterConfig<TData = Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissionsFilterConfig>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissionsFilterConfig>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContactSubmissionsGetContactSubmissionsFilterConfigQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * @summary Get contact submissions summary with counts by status
 */
export const contactSubmissionsGetContactSubmissionsSummary = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<ContactSubmissionsSummaryDTO>(
      {url: `/api/site-admin/ContactSubmissions/summary`, method: 'GET', signal
    },
      );
    }
  

export const getContactSubmissionsGetContactSubmissionsSummaryQueryKey = () => {
    return [`/api/site-admin/ContactSubmissions/summary`] as const;
    }

    
export const getContactSubmissionsGetContactSubmissionsSummaryQueryOptions = <TData = Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissionsSummary>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissionsSummary>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContactSubmissionsGetContactSubmissionsSummaryQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissionsSummary>>> = ({ signal }) => contactSubmissionsGetContactSubmissionsSummary(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissionsSummary>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContactSubmissionsGetContactSubmissionsSummaryQueryResult = NonNullable<Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissionsSummary>>>
export type ContactSubmissionsGetContactSubmissionsSummaryQueryError = ErrorType<unknown>


export function useContactSubmissionsGetContactSubmissionsSummary<TData = Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissionsSummary>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissionsSummary>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissionsSummary>>,
          TError,
          Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissionsSummary>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContactSubmissionsGetContactSubmissionsSummary<TData = Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissionsSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissionsSummary>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissionsSummary>>,
          TError,
          Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissionsSummary>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContactSubmissionsGetContactSubmissionsSummary<TData = Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissionsSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissionsSummary>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get contact submissions summary with counts by status
 */

export function useContactSubmissionsGetContactSubmissionsSummary<TData = Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissionsSummary>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactSubmissionsGetContactSubmissionsSummary>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContactSubmissionsGetContactSubmissionsSummaryQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const contactSubmissionsGetContactSubmission = (
    id: number,
 signal?: AbortSignal
) => {
      
      
      return customInstance<ContactSubmissionDetailDTO>(
      {url: `/api/site-admin/ContactSubmissions/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getContactSubmissionsGetContactSubmissionQueryKey = (id: number,) => {
    return [`/api/site-admin/ContactSubmissions/${id}`] as const;
    }

    
export const getContactSubmissionsGetContactSubmissionQueryOptions = <TData = Awaited<ReturnType<typeof contactSubmissionsGetContactSubmission>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactSubmissionsGetContactSubmission>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getContactSubmissionsGetContactSubmissionQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof contactSubmissionsGetContactSubmission>>> = ({ signal }) => contactSubmissionsGetContactSubmission(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof contactSubmissionsGetContactSubmission>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ContactSubmissionsGetContactSubmissionQueryResult = NonNullable<Awaited<ReturnType<typeof contactSubmissionsGetContactSubmission>>>
export type ContactSubmissionsGetContactSubmissionQueryError = ErrorType<unknown>


export function useContactSubmissionsGetContactSubmission<TData = Awaited<ReturnType<typeof contactSubmissionsGetContactSubmission>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactSubmissionsGetContactSubmission>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof contactSubmissionsGetContactSubmission>>,
          TError,
          Awaited<ReturnType<typeof contactSubmissionsGetContactSubmission>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContactSubmissionsGetContactSubmission<TData = Awaited<ReturnType<typeof contactSubmissionsGetContactSubmission>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactSubmissionsGetContactSubmission>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof contactSubmissionsGetContactSubmission>>,
          TError,
          Awaited<ReturnType<typeof contactSubmissionsGetContactSubmission>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useContactSubmissionsGetContactSubmission<TData = Awaited<ReturnType<typeof contactSubmissionsGetContactSubmission>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactSubmissionsGetContactSubmission>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useContactSubmissionsGetContactSubmission<TData = Awaited<ReturnType<typeof contactSubmissionsGetContactSubmission>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof contactSubmissionsGetContactSubmission>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getContactSubmissionsGetContactSubmissionQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const contactSubmissionsUpdateContactSubmissionStatus = (
    id: number,
    updateContactSubmissionStatusDTO: UpdateContactSubmissionStatusDTO,
 ) => {
      
      
      return customInstance<void>(
      {url: `/api/site-admin/ContactSubmissions/${id}/status`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateContactSubmissionStatusDTO
    },
      );
    }
  


export const getContactSubmissionsUpdateContactSubmissionStatusMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contactSubmissionsUpdateContactSubmissionStatus>>, TError,{id: number;data: UpdateContactSubmissionStatusDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof contactSubmissionsUpdateContactSubmissionStatus>>, TError,{id: number;data: UpdateContactSubmissionStatusDTO}, TContext> => {
    
const mutationKey = ['contactSubmissionsUpdateContactSubmissionStatus'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof contactSubmissionsUpdateContactSubmissionStatus>>, {id: number;data: UpdateContactSubmissionStatusDTO}> = (props) => {
          const {id,data} = props ?? {};

          return  contactSubmissionsUpdateContactSubmissionStatus(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContactSubmissionsUpdateContactSubmissionStatusMutationResult = NonNullable<Awaited<ReturnType<typeof contactSubmissionsUpdateContactSubmissionStatus>>>
    export type ContactSubmissionsUpdateContactSubmissionStatusMutationBody = UpdateContactSubmissionStatusDTO
    export type ContactSubmissionsUpdateContactSubmissionStatusMutationError = ErrorType<unknown>

    export const useContactSubmissionsUpdateContactSubmissionStatus = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof contactSubmissionsUpdateContactSubmissionStatus>>, TError,{id: number;data: UpdateContactSubmissionStatusDTO}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof contactSubmissionsUpdateContactSubmissionStatus>>,
        TError,
        {id: number;data: UpdateContactSubmissionStatusDTO},
        TContext
      > => {

      const mutationOptions = getContactSubmissionsUpdateContactSubmissionStatusMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    